import { format } from "date-fns";
import { enUS, fr } from "date-fns/locale";

export function formatDate(date, formatStr) {
  return format(date, formatStr, { locale: I18nLocale === "fr" ? fr : enUS });
}

export function formatDateWithDashes(date) {
 return date.toString().split('T')[0];
}
